<template>
  <div class="page-bg">
    <div class="login">
      <div class="login-bg">
        <div class="tip">
          Hi，下午好，欢迎来到昌都市土地二级市场交易服务平台
        </div>
        <div class="avatar">
          <img src="@/assets/images/avatar.png" alt="" />
        </div>
        <div class="login-tip">
          {{ profile.token ? profile.account : "请先登录" }}
        </div>
        <div class="btn" v-if="!profile.token">
          <el-button plain @click="$router.push('/login')">登录</el-button>
          <el-button plain @click="$router.push('/register?type=sign')">注册</el-button>
        </div>
        <div class="btn" v-if="profile.token">
          <el-button plain @click="$router.push('/member')">个人中心</el-button>
          <el-button plain @click="logout()">注销</el-button>
        </div>
        <div class="help">
          <a @click="$router.push('/service-center')">帮助中心</a>
          <span>服务热线：0895-4821857</span>
        </div>
      </div>
    </div>
  </div>
  <div class="controls">
    <div class="controls-list">
      <div class="controls-item" v-for="(item, i) in groundList" :key="i" @click="formRouter(item.url)">
        <div class="controls-img">
          <img v-if="i == 0" src="@/assets/images/index/out.png" alt="" />
          <img v-if="i == 1" src="@/assets/images/index/sell.png" alt="" />
          <img v-if="i == 2" src="@/assets/images/index/pledge.png" alt="" />
          <img v-if="i == 3" src="@/assets/images/index/rent.png" alt="" />
          <img v-if="i == 4" src="@/assets/images/index/buy.png" alt="" />
        </div>
        <div class="controls-txt">
          <div>{{ item.label }}</div>
          <div class="controls-Tibetan">{{ item.tibetan }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="main">
    <!-- 轮播图与文章部分 -->
    <div class="swiper-policy">
      <div class="swiper-content">
        <el-carousel ref="swiper" height="26.375rem" :autoplay="true" arrow="never" indicator-position="none"
          @change="swiperChange">
          <el-carousel-item v-for="(item, i) in recommendActive" :key="i">
            <div class="swiper-content-img" :style="'background-image: url(' + Config.domainUrl + item.cover + ')'
            ">
              <!-- <img src="@/assets/images/index/illustration.png" alt=""> -->
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="carousel">
          <div class="content">
            {{ recommendActive[active] ? recommendActive[active].title : "" }}
          </div>
          <div class="indicators-list">
            <!-- 这里因为是自己写的轮播图指示点 所以轮播图的数组长度是多少这里就循环几次 也就是v-for共用一个循环 -->
            <div v-for="(item, i) in recommendActive" :key="i" class="indicators-item"
              :class="i == active ? 'is-active' : ''" @click="onIncClick(i)" @mouseenter="onIncClick(i)"></div>
          </div>
        </div>
      </div>
      <div class="policy">
        <div class="policy-head">
          <div class="policy-head-left">
            <div v-for="(item, i) in cateIds" :key="i" @click="onNews(item)" :class="item.isNew ? 'is-active' : ''">
              {{ item.label }}
            </div>
          </div>
          <div class="policy-head-right" @click="$router.push('/policies-regulations?type=policies')">
            更多>>
          </div>
        </div>
        <div class="policy-list">
          <div class="policy-item" v-for="(item, i) in activeList" :key="i">
            <div class="inc"></div>
            <div class="title" @click="
            $router.push(
              `/public-announcement/details?type=policiesRegulations&&id=${item.id}`
            )
            ">
              {{ item.title }}
            </div>
            <div class="time">
              {{ timeProcessing(item.created_at) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 监管系统 业务系统 一级市场。。。。。 -->
    <div class="banner">
      <div class="banner-left">
        <div v-for="(item, index) in bannerList" :key="index" class="banner-left-item"
          :class="index == 0 ? '' : index == 1 ? 'business-bg' : 'first-bg'">
          <div v-for="(vitem, i) in item" :key="i" @click="onFeature(vitem)">
            <span class="iconfont icon-project-audit" :class="vitem.icon"></span>
            <div>{{ vitem.name }}</div>
          </div>
        </div>
      </div>
      <div class="banner-right">
        <div class="item" @click="onSkip('http://zrzy.changdu.gov.cn/')">
          昌都市自然资源局
        </div>
        <div class="item right-bg1" @click="onSkip('http://chd.ggzy.xizang.gov.cn/')">
          昌都市公共资源交易平台
        </div>
        <div class="item right-bg2" @click="onSkip('https://zrzyt.xizang.gov.cn/')">
          西藏自治区自然资源厅
        </div>
        <div class="item right-bg3" @click="onSkip('https://ggzy.xizang.gov.cn/')">
          西藏自治区公共资源交易平台
        </div>
      </div>
    </div>
    <!-- 供给信息 -->
    <div class="supply">
      <HomeHead icon="icon-supply" title="供给信息" :list="supplyScreenList" @onScreen="screenClick"
        @more="$router.push(`/trading-floor?screenNum=${screenNum}`)" />
      <div>
        <!-- 商品展示 -->
        <ProductList :list="proList" :isState="false" :isPledeg="screenNum == 2" />
      </div>
    </div>
    <!-- 需求信息 -->
    <div class="requirement">
      <HomeHead icon="icon-requirement" color="#17D16B" title="需求信息" :list="requirementScreenList"
        @onScreen="requirementClick" @more="$router.push(`/land-demand?requirementNum=${requirementNum}`)" />
      <DemandListModule :list="demList"></DemandListModule>
    </div>
  </div>
  <!-- 地图交易数据 -->
  <div class="map">
    <div class="map-main">
      <HomeHead :isBorder="false" icon="icon-map" color="#349BF9" title="地图交易数据" :list="mapScreenList"
        @onScreen="mapClick" :isMore="false" />
      <div class="title">{{ mapName }}</div>
      <div class="tip" v-if="mapName != '昌都市'">
        注：再次点击相同地区返回市本级数据
      </div>
      <div class="map-data">
        <div class="map">
          <appStatisticsMap @onMapClick="onMap" />
        </div>
        <div class="data" v-if="promise.type == 'project'">
          <div class="data-commonality data-title">累计已交易土地（亩）</div>
          <div class="data-commonality data-num">
            {{ mapInfo.finishedValue }}
          </div>
          <div class="data-commonality data-title">累计已发布土地（亩）</div>
          <div class="data-commonality data-num">{{ mapInfo.totalValue }}</div>
          <div class="data-commonality data-title">土地转让（亩）</div>
          <div class="data-commonality data-num">{{ mapInfo.type1Value }}</div>
          <div class="data-commonality data-title">土地出租（亩）</div>
          <div class="data-commonality data-num">{{ mapInfo.type2Value }}</div>
          <!-- <div class="data-commonality data-title">土地抵押（亩）</div>
          <div class="data-commonality data-num">{{ mapInfo.type3Value }}</div> -->
        </div>
        <div class="data" v-else>
          <div class="data-commonality data-title">求租（亩）</div>
          <div class="data-commonality data-num">{{ mapInfo.type2Value }}</div>
          <div class="data-commonality data-title">求购（亩）</div>
          <div class="data-commonality data-num">{{ mapInfo.type1Value }}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- 回到顶部 -->
  <el-backtop :bottom="100">
    <div style="
        height: 100%;
        width: 100%;
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      ">
      <span class="iconfont icon-back-top"></span>
    </div>
  </el-backtop>
  <!-- 合同类型弹窗 -->
  <contractType ref="contractTypeRef"></contractType>
</template>

<script setup>
import contractType from "./components/contract-type.vue";
import HomeHead from "./components/home-head.vue";
import appStatisticsMap from "@/components/app-statistics-map.vue";
import { ref, computed, nextTick } from "vue";
import ProductList from "@/components/product-list.vue";
import DemandListModule from "@/components/demand-list.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { projectList, demandList } from "@/api/trading-floor";
import { reportDetail, reportGraph } from "@/api/data-analysis";
import { getArticleRecommends, getArticle } from "@/api/article";
import Config from "@/global-config.js";
import { timeProcessing } from "@/utils/time";
import { findAllCategory } from "@/api/category";
import { userProfile } from "@/api/user";

// 地图返回数据
const mapInfo = ref({});

//  监管系统 业务系统 一级市场。。。。。
const bannerList = ref([
  [
    {
      name: "项目审核",
      icon: "icon-project-audit",
    },
    {
      name: "数据统计分析",
      icon: "icon-statistics",
    },
  ],
  [
    {
      name: "不动产登记",
      icon: "icon-sign-in",
    },
    {
      name: "合同服务",
      icon: "icon-contract",
    },
  ],
  [
    {
      name: "招标公告",
      icon: "icon-announcement",
    },
    {
      name: "结果公示",
      icon: "icon-publicity",
    },
  ],
]);

const store = useStore();
const router = useRouter();
// 使用vuex中的state需要设置计算属性
const profile = computed(() => {
  return store.state.user.profile;
});
// 是否新闻动态
const isNew = ref(true);
// 轮播图下面的小点切换
const active = ref(0);
const swiperChange = (val) => {
  active.value = val;
};
const swiper = ref(null);
const onIncClick = (val) => {
  swiper.value.setActiveItem(val);
};

const cateIds = ref([
  {
    label: '新闻动态',
    value: '',
    isNew: true
  }, {
    label: '政策法规',
    value: '',
    isNew: false
  }
])

const onNews = (val) => {
  getActive({
    type: "article.policy",
    cate_id: val.value,
    page: 1,
  });
  cateIds.value.forEach(item => {
    item.isNew = !item.isNew
  })
};

const getFindAllCategory = () => {
  findAllCategory({ group: 'article.policy' }).then(res => {
    if (res && res.code == 200) {
      cateIds.value.forEach(item => {
        res.data.forEach(v => {
          if (item.label == v.name) {
            item.value = v.id
          }
          if (v.name == '新闻动态') {
            getActive({
              type: "article.policy",
              cate_id: v.id,
              page: 1,
            });
          }
        })
      })
    }
  })
}
getFindAllCategory()
// 推荐文章(新闻动态、政策法规)
const activeList = ref([]);
// 获取推荐文章
const getActive = (val) => {
  getArticle(val).then((res) => {
    if (res) {
      if (res.code == 200) {
        activeList.value =
          res.data.list.length > 6 ? res.data.list.slice(0, 6) : res.data.list;
      }
    }
  });
};
// 点击的值
const screenNum = ref(0);

// 供给信息head筛选列表
const supplyScreenList = ref(["土地转让", "土地出租"]);

// 供给信息组件返回值（点击中间部分）
const screenClick = (val) => {
  screenNum.value = val;
  console.log(val, "val");
  getList(val);
};

// 供给信息组件返回值(点击更多)
const onMore = () => {
  console.log("点击了更多");
};

// 需求信息head筛选列表

// 需求列表数据
const demList = ref([]);

// 点击的值
const requirementNum = ref(2);

const requirementScreenList = ref(["土地求购", "土地求租"]);

// 需求信息组件返回值（点击中间部分）
const requirementClick = (val) => {
  console.log(val, "val");
  let type = val == 0 ? 1 : 2;
  requirementNum.value = type;
  getListdemaned(type);
};

// 地图交易数据
const mapScreenList = ref(["土地供给", "土地需求"]);

// 需求信息组件返回值（点击中间部分）
const mapClick = (val) => {
  promise.value.type = val == 0 ? "project" : "demand";
  getMap(promise.value);
};

// 需求信息组件返回值(点击更多)
const onRequirementMore = () => {
  console.log("点击了更多");
};

// 土地交易选项
const groundList = ref([
  {
    label: "土地出租",
    tibetan: "ས་ཞིང་བོགས་མར་གཏོང་བ་",
    url: "/rent-out?type=2",
  },
  {
    label: "土地转让",
    tibetan: "ས་ཞིང་བཤུག་སྤྲོད་",
    url: "/rent-out?type=1",
  },
  // {
  //   label: "土地抵押",
  //   tibetan: "ས་ཞིང་གཏའ་མར་འཇོག་པ།",
  //   url: "/rent-out?type=3",
  // },
  {
    label: "土地求租",
    tibetan: "ས་ཞིང་བོགས་མར་ལེན་པ་",
    url: "/rent-tenancy?type=2",
  },
  {
    label: "土地求购",
    tibetan: "ས་ཞིང་ཉོ་སྒྲུབ་",
    url: "/rent-tenancy?type=1",
  },
]);

// 退出登录1.清空vuex和本地存储，本地购物车2.跳转
const logout = () => {
  store.commit("user/setUser", {});
  store.commit("cart/setCart", []);
  // router.push("/login");
};

const contractTypeRef = ref(null);

// 点击功能按钮
const onFeature = (data) => {
  switch (data.name) {
    case "项目审核":
      window.open(
        "http://landtrade-admin.wpgcms.com/#/login?redirect=%2Fdashboard"
      );
      break;
    case "数据统计分析":
      router.push("/data-analysis");
      break;
    case "不动产登记":
      break;
    case "合同服务":
      userProfile().then((res) => {
        if (res && res.code == 200) {
          router.push("/member/contract/edit");
        }
      });
      break;
    case "招标公告":
      router.push("/public-announcement");
      break;
    case "结果公示":
      router.push("/public-announcement");
      break;
  }
};

// 点击各网址
const onSkip = (data) => {
  window.open(data);
};

const proList = ref([]);

// 请求列表数据（供给信息）
const getList = (val) => {
  console.log(val, "val");
  let type = val + 1;
  projectList({ type, page: 1 }).then((res) => {
    if (res && res.code == 200) {
      proList.value =
        res.data.list.length > 8 ? res.data.list.slice(0, 8) : res.data.list;
    }
  });
};

getList(0);

// 请求列表数据（需求信息）
const getListdemaned = (type) => {
  demandList({ type, page: 1 }).then((res) => {
    if (res && res.code == 200) {
      demList.value =
        res.data.list.length > 4 ? res.data.list.slice(0, 4) : res.data.list;
    }
  });
};
getListdemaned(1);

// 地图请求数据
const promise = ref({
  type: "project",
  data_type: "area",
});

const getMap = (form) => {
  // 地图
  reportDetail(form).then((res) => {
    if (res && res.code == 200) {
      mapInfo.value = res.data;
    }
  });
};
getMap(promise.value);

const mapName = ref("昌都市");

// 点击了县城
const onMap = (val) => {
  if (promise.value.district && promise.value.district == val.data.district) {
    promise.value.district = "";
    mapName.value = "昌都市";
  } else {
    promise.value.district = val.data.district;
    mapName.value = val.name;
  }
  getMap(promise.value);
};

// 推荐文章
const recommendActive = ref([]);
// 获取推荐文章
const getActiveRecommends = () => {
  getArticleRecommends().then((res) => {
    if (res) {
      if (res.code == 200) {
        recommendActive.value = res.data;
      }
    }
  });
};
getActiveRecommends();

// 出租转让抵押求租求购表单跳转
const formRouter = (val) => {
  userProfile().then((res) => {
    if (res && res.code == 200) {
      router.push(val)
    }
  });
}

</script>

<style scoped lang="less">
.page-bg {
  background-image: url(@/assets/images/bg3.png);
  background-size: 100% 69rem;
  width: 100%;
  height: 58rem;
  background-repeat: no-repeat;

  .login {
    position: relative;
    width: 85rem;
    margin: 0 auto;

    .login-bg {
      position: absolute;
      top: 24.1875rem;
      right: 0;
      width: 34.437rem;
      height: 21.062rem;
      border-radius: 0.625rem;
      background-color: rgba(255, 255, 255, 0.75);
      text-align: center;
      padding: 1.25rem 0;

      .tip {
        font-size: 1.125rem;
        color: #999999;
      }

      .avatar {
        width: 6.25rem;
        height: 6.25rem;
        margin: 0 auto;
        margin-top: 1.25rem;
      }

      .login-tip {
        font-size: 1.375rem;
        color: #666666;
        margin-top: 1.25rem;
      }

      .btn {
        margin-top: 1.25rem;

        .el-button {
          background: transparent;
          color: #407cc0;
          border-color: #407cc0;
          width: 6.25rem;
        }

        .el-button:last-child {
          margin-left: 2.687rem;
        }
      }

      .help {
        margin-top: 1.25rem;
        font-size: 1.125rem;

        a {
          display: inline-block;
          color: #349bf9;
          padding: 0 1.25rem 0 0;
          border-right: 0.2rem solid #999;
        }

        span {
          color: #999999;
          padding: 0 0 0 1.25rem;
        }
      }
    }
  }
}

.controls {
  background: #fff;
  height: 11.25rem;
  width: 100%;

  .controls-list {
    width: 85rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 100%;

    .controls-item {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 18.75rem;

      .controls-img {
        width: 3.75rem;
        height: 3.75rem;
        margin-right: 1.25rem;
        overflow: hidden;
        border-radius: 50%;

        img {
          border-radius: 50%;
          transition-duration: 1.5s;
        }

        img:hover {
          transform: scale(1.5);
        }
      }

      .controls-txt {
        /* 我要租地 */
        font-size: 1.5rem;
        color: #333333;

        .controls-Tibetan {
          /* ངས་ས་ཞིང་གླ་དགོས་། */
          font-size: 1rem;
          font-weight: normal;
          color: #666666;
        }
      }
    }
  }
}

.main {
  width: 85rem;
  margin: 0 auto;
  margin-top: 1.812rem;

  // 轮播图与文章部分
  .swiper-policy {
    width: 100%;
    height: 26.375rem;
    display: flex;
    justify-content: space-between;

    .swiper-content {
      width: 50rem;
      position: relative;

      .swiper-content-img {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }

      .carousel {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3.75rem;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1.25rem;

        .content {
          width: 25rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 1.375rem;
          font-weight: bold;
          color: #ffffff;
        }

        .indicators-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 8.75rem;

          .indicators-item {
            width: 1.25rem;
            height: 1.25rem;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.5);
            cursor: pointer;
          }

          .is-active {
            background: #349bf9;
          }
        }
      }
    }

    .policy {
      width: 36.25rem;
      height: 100%;
      background: #ffffff;
      margin-left: 1.25rem;
      overflow: hidden;

      .policy-head {
        width: 100%;
        height: 3.75rem;
        background: #ffffff;
        box-sizing: border-box;
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1.375rem;

        .policy-head-left {
          display: flex;
          height: 100%;
          align-items: center;

          div {
            width: 6.25rem;
            height: 100%;
            font-size: 1.5rem;
            color: #666666;
            margin-right: 2.5rem;
            cursor: pointer;
            display: flex;
            align-items: center;
          }

          .is-active {
            color: #349bf9;
            border-bottom: 0.187rem solid #349bf9;
          }
        }

        .policy-head-right {
          /* 更多>> */
          font-size: 1rem;
          color: #bfbfbf;
          cursor: pointer;
        }
      }

      .policy-list {
        overflow: hidden;

        .policy-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 1.937rem 1rem 1.25rem;
          cursor: pointer;

          .inc {
            width: 0.625rem;
            height: 0.625rem;
            background: #b0d0e7;
            border-radius: 50%;
          }

          .title {
            width: 25rem;
            font-size: 1.25rem;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .title:hover {
            color: #349bf9;
          }

          .time {
            font-size: 1rem;
            color: #999999;
          }
        }
      }
    }
  }

  // 监管系统 业务系统 一级市场。。。。。
  .banner {
    margin-top: 1.875rem;
    display: flex;
    justify-content: space-between;

    .banner-left {
      .banner-left-item {
        width: 60rem;
        height: 12rem;
        background-image: url(@/assets/images/index/supervise.png);
        background-size: cover;
        background-repeat: round;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 5.312rem 0 6.062rem;
        font-size: 1.5rem;
        color: #ffffff;
        text-align: center;

        .iconfont {
          font-size: 2rem;
        }

        div:first-child {
          width: 7.5rem;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        div:last-child {
          width: 9rem;
          cursor: pointer;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }

      .business-bg {
        background-image: url(@/assets/images/index/business.png);
        margin-top: 0.625rem;
      }

      .first-bg {
        background-image: url(@/assets/images/index/first.png);
        margin-top: 0.625rem;
      }
    }

    .banner-right {
      margin-left: 1.25rem;

      .item {
        width: 24rem;
        height: 8.82rem;
        background-image: url(@/assets/images/index/right-bg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        color: #ffffff;
        margin-bottom: 0.625rem;
        font-weight: bold;
        transition-duration: 2s;
        cursor: pointer;
      }

      .item:hover {
        background-size: 120% 120%;
      }

      .item:last-child {
        margin-bottom: 0;
      }

      .right-bg1 {
        background-image: url(@/assets/images/index/right-bg1.png);
      }

      .right-bg2 {
        background-image: url(@/assets/images/index/right-bg2.png);
      }

      .right-bg3 {
        background-image: url(@/assets/images/index/right-bg3.png);
      }
    }
  }

  // 供给信息
  .supply {
    margin-top: 1.875rem;
    background: #fff;
  }

  // 需求信息
  .requirement {
    margin-top: 1.875rem;
    background: #fff;

    .requirement-list {
      .requirement-item {
        padding: 1.25rem;
        position: relative;

        .title {
          font-size: 1.375rem;
          color: #333333;
        }

        .info {
          display: flex;
          margin-top: 1.375rem;

          div {
            div {
              font-size: 0.75rem;
              color: #333333;
              margin-top: 0.625rem;

              .lable {
                color: #999999;
              }
            }
          }

          .info-right {
            margin-left: 7.187rem;
          }
        }

        .price {
          position: absolute;
          top: 3.062rem;
          right: 5rem;
          text-align: center;

          .text {
            /* 求购价 */
            font-size: 1rem;
            color: #999999;
          }

          .num {
            font-size: 1.375rem;
            font-weight: bold;
            color: #f93434;
            margin-top: 0.625rem;
          }
        }
      }
    }
  }

  // end
}

.map {
  width: 100%;
  background: #fff;
  height: 56.5rem;

  .map-main {
    width: 85rem;
    margin: 0 auto;

    .title {
      /* 昌都市 */
      text-align: center;
      font-size: 2.375rem;
      color: #000000;
      margin-top: 3rem;
    }

    .tip {
      text-align: center;
      color: #999999;
    }

    .map-data {
      display: flex;
      margin-top: 1rem;

      .map {
        width: 43.75rem;
        height: 38.5rem;
      }

      .data {
        margin-left: 12.5rem;

        .data-commonality {
          background: #eaf3fb;
          width: 18.75rem;
          padding-left: 1.25rem;
          color: #999999;
        }

        .data-title {
          height: 2.5rem;
          font-size: 1rem;
          line-height: 2.5rem;
        }

        .data-num {
          height: 5rem;
          line-height: 5rem;
          font-size: 1.75rem;
          color: #333333;
          border-bottom: 1px solid #fff;
        }

        .data-num:nth-child(4) {
          margin-bottom: 0.625rem;
        }

        .data-num:hover {
          color: #f93434;
        }
      }
    }
  }
}
</style>
